import { render, staticRenderFns } from "./PartyOnboardingAddress.vue?vue&type=template&id=89227cfc"
import script from "./PartyOnboardingAddress.vue?vue&type=script&lang=js"
export * from "./PartyOnboardingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports